import React, { useState } from 'react';
import { Download, Sparkles, Copy, Check, Sliders, Play, RotateCcw, ZoomIn, ZoomOut, Maximize2, Minimize2, Send, Shield } from 'lucide-react';

export function CanvasToolbar({
  onExport,
  onSendToUpscaler,
  onSendToRelight,
  onCopyPrompt,
  onReroll,
  onLaunchMetaAds,
  isPlaying,
  onTogglePlay,
  zoomLevel = 1,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  isFullscreen,
  onToggleFullscreen,
  showSafeZones = false,
  onToggleSafeZones
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (onCopyPrompt) onCopyPrompt();
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      background: 'rgba(15, 17, 24, 0.85)',
      backdropFilter: 'blur(16px)',
      padding: '6px 10px',
      borderRadius: '10px',
      border: '1px solid rgba(255,255,255,0.1)',
      boxShadow: '0 8px 30px rgba(0,0,0,0.5)',
      zIndex: 30
    }}>
      {/* Zoom Controls */}
      <button
        type="button"
        onClick={onZoomOut}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#cbd5e1',
          padding: '5px',
          borderRadius: '5px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center'
        }}
        title="Alejar Zoom (-)"
      >
        <ZoomOut size={13} />
      </button>

      <button
        type="button"
        onClick={onResetZoom}
        style={{
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.08)',
          color: '#c084fc',
          padding: '3px 7px',
          borderRadius: '5px',
          fontSize: '11px',
          fontWeight: 600,
          cursor: 'pointer'
        }}
        title="Restablecer zoom al 100%"
      >
        {Math.round(zoomLevel * 100)}%
      </button>

      <button
        type="button"
        onClick={onZoomIn}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#cbd5e1',
          padding: '5px',
          borderRadius: '5px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center'
        }}
        title="Acercar Zoom (+)"
      >
        <ZoomIn size={13} />
      </button>

      {/* Fullscreen Button */}
      <button
        type="button"
        onClick={onToggleFullscreen}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#cbd5e1',
          padding: '5px',
          borderRadius: '5px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center'
        }}
        title={isFullscreen ? 'Salir de pantalla completa' : 'Modo Pantalla Completa'}
      >
        {isFullscreen ? <Minimize2 size={13} /> : <Maximize2 size={13} />}
      </button>

      <div style={{ width: '1px', height: '16px', background: 'rgba(255,255,255,0.1)' }} />

      <button
        type="button"
        onClick={onTogglePlay}
        style={{
          background: isPlaying ? 'rgba(168,85,247,0.25)' : 'rgba(255,255,255,0.05)',
          border: isPlaying ? '1px solid #a855f7' : '1px solid rgba(255,255,255,0.08)',
          color: isPlaying ? '#c084fc' : '#cbd5e1',
          padding: '6px 10px',
          borderRadius: '6px',
          fontSize: '11px',
          fontWeight: 600,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '5px'
        }}
        title="Reproducir animación de toma"
      >
        <Play size={13} fill={isPlaying ? '#c084fc' : 'none'} />
        <span>{isPlaying ? 'Pausar' : 'Play'}</span>
      </button>

      <div style={{ width: '1px', height: '16px', background: 'rgba(255,255,255,0.1)' }} />


      <button
        type="button"
        onClick={onReroll}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#cbd5e1',
          padding: '6px 8px',
          borderRadius: '6px',
          fontSize: '11px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '5px'
        }}
        title="Generar nueva variación con misma semilla"
      >
        <RotateCcw size={13} />
        <span>Re-roll</span>
      </button>

      <button
        type="button"
        onClick={handleCopy}
        style={{
          background: 'transparent',
          border: 'none',
          color: copied ? '#10b981' : '#cbd5e1',
          padding: '6px 8px',
          borderRadius: '6px',
          fontSize: '11px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '5px'
        }}
        title="Copiar prompt actual al portapapeles"
      >
        {copied ? <Check size={13} /> : <Copy size={13} />}
        <span>{copied ? 'Copiado' : 'Prompt'}</span>
      </button>

      <div style={{ width: '1px', height: '16px', background: 'rgba(255,255,255,0.1)' }} />

      <button
        type="button"
        onClick={onSendToUpscaler}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#c084fc',
          padding: '6px 8px',
          borderRadius: '6px',
          fontSize: '11px',
          fontWeight: 600,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '5px'
        }}
        title="Enviar este fotograma a AI Upscaler 4K"
      >
        <Sparkles size={13} />
        <span>Upscale 4K</span>
      </button>

      <button
        type="button"
        onClick={onSendToRelight}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#fbbf24',
          padding: '6px 8px',
          borderRadius: '6px',
          fontSize: '11px',
          fontWeight: 600,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '5px'
        }}
        title="Enviar escena a Relight Engine"
      >
        <Sliders size={13} />
        <span>Relight</span>
      </button>

      <div style={{ width: '1px', height: '16px', background: 'rgba(255,255,255,0.1)' }} />

      {/* Toggle Zonas Seguras Meta (Safe Zones) */}
      <button
        type="button"
        onClick={onToggleSafeZones}
        style={{
          background: showSafeZones ? 'rgba(6, 182, 212, 0.2)' : 'transparent',
          border: showSafeZones ? '1px solid #06b6d4' : '1px solid rgba(255,255,255,0.08)',
          color: showSafeZones ? '#22d3ee' : '#94a3b8',
          padding: '6px 10px',
          borderRadius: '6px',
          fontSize: '11px',
          fontWeight: 700,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
          boxShadow: showSafeZones ? '0 0 14px rgba(6, 182, 212, 0.35)' : 'none',
          transition: 'all 0.2s ease'
        }}
        title="Mostrar / Ocultar plantilla de Zonas Seguras de Meta (Reels/Stories) para evitar que los botones tapen tu texto"
      >
        <Shield size={12} color={showSafeZones ? '#22d3ee' : '#94a3b8'} />
        <span>{showSafeZones ? 'Zonas Seguras: ON' : 'Zonas Seguras Meta'}</span>
      </button>

      <div style={{ width: '1px', height: '16px', background: 'rgba(255,255,255,0.1)' }} />

      {/* Botón Lanzar a Meta Ads */}
      <button
        type="button"
        onClick={onLaunchMetaAds}
        style={{
          background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
          border: 'none',
          color: '#fff',
          padding: '6px 12px',
          borderRadius: '6px',
          fontSize: '11px',
          fontWeight: 700,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
          boxShadow: '0 2px 10px rgba(37, 99, 235, 0.4)'
        }}
        title="Lanzar este video como campaña en Facebook e Instagram Ads"
      >
        <Send size={12} />
        <span>Lanzar Meta Ads</span>
      </button>

      <button
        type="button"
        onClick={onExport}
        style={{
          background: 'linear-gradient(135deg, #a855f7, #6366f1)',
          border: 'none',
          color: '#fff',
          padding: '6px 12px',
          borderRadius: '6px',
          fontSize: '11px',
          fontWeight: 700,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
          boxShadow: '0 2px 10px rgba(168,85,247,0.3)'
        }}
        title="Descargar toma en alta definición"
      >
        <Download size={13} />
        <span>Descargar</span>
      </button>
    </div>
  );
}
